import React from 'react';
import Icon from '../Icon';
import svg from '../icons/security-secure.js';

const IconSecuritySecure = (props) => <Icon {...props} svg={svg} />;

IconSecuritySecure.displayName = 'IconSecuritySecure';

export default IconSecuritySecure;
